import { cn } from '@/lib/utils/cn';

/** Compact HGNICE wordmark using Bangladesh-inspired green and red. */
export function Brand({ collapsed = false, className }: { collapsed?: boolean; className?: string }) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <div
        className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-sm font-bold text-white shadow-sm"
        style={{ background: 'linear-gradient(135deg, #08783e, #005a30)' }}
      >
        HG
      </div>
      {!collapsed ? (
        <div className="leading-tight">
          <div className="text-sm font-semibold text-sidebar-foreground">HGNICE</div>
          <div className="text-[10px] uppercase tracking-widest text-sidebar-foreground/50">Admin Console</div>
        </div>
      ) : null}
    </div>
  );
}
